goog.provide("shadow.js.shim.module$src$svg$controls$zoom_svg");
goog.provide("module$shadow_js_shim_module$src$svg$controls$zoom_svg");
shadow.js.shim.module$src$svg$controls$zoom_svg = shadow.js.nativeProvides["src/svg/controls/zoom.svg"] = shadow$bridge("src/svg/controls/zoom.svg");
module$shadow_js_shim_module$src$svg$controls$zoom_svg.default = shadow.js.shim.module$src$svg$controls$zoom_svg;
